import formActions from './form/action';
import authActions from './auth/action';
import graphqlActionCreators from './graphql/actionCreators';
import authActionCreators from './auth/actionCreators';
import userActions from './user/action';
import userActionCreators from './user/actionCreators';
import productActions from './product/action';
import productActionCreators from './product/actionCreators';
import modalActions from './modal/action';
import modalActionCreators from './modal/actionCreators';
import bannerActions from './banner/action';
import bannerActionCreators from './banner/actionCreators';
import formActionCreators from './form/actionCreators';
import socketActionCreators from './socket/actionCreators';
import printActionCreators from './print/actionCreators';
import printActions from './print/action';
import ticketActions from './ticket/action';
import ticketActionCreators from './ticket/actionCreators';
import invoiceActions from './invoice/action';
import invoiceActionCreators from './invoice/actionCreators';
import ValidityActions from './validity/action';
import validityActionCreators from './validity/actionCreators';

const rootSetters = (dispatch: (action: any) => any) =>
  Object.assign(
    {},
    {
      auth: {
        ...authActions(dispatch),
        ...authActionCreators(dispatch),
      },
      user: {
        ...userActions(dispatch),
        ...userActionCreators(dispatch),
      },
      form: {
        ...formActions(dispatch),
        ...formActionCreators(dispatch),
      },
      modal: {
        ...modalActions(dispatch),
        ...modalActionCreators(dispatch),
      },
      banner: {
        ...bannerActions(dispatch),
        ...bannerActionCreators(dispatch),
      },
      graphql: {
        ...graphqlActionCreators(dispatch),
      },
      product: {
        ...productActions(dispatch),
        ...productActionCreators(dispatch),
      },
      socket: {
        ...socketActionCreators(dispatch),
      },
      print: {
        ...printActions(dispatch),
        ...printActionCreators(dispatch),
      },
      ticket: {
        ...ticketActions(dispatch),
        ...ticketActionCreators(dispatch),
      },
      invoice: {
        ...invoiceActions(dispatch),
        ...invoiceActionCreators(dispatch),
      },
      validity: {
        ...ValidityActions(dispatch),
        ...validityActionCreators(dispatch),
      },
    },
  );

export default rootSetters;
